import React, { useMemo, useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from "react-redux"
import { Button } from "reactstrap"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "../../../components/Common/DataTableContainer"
import { getAwardsList } from "../../../redux/actions/awards"

const AwardsList = () => {
  document.title = "PULA Awards List"

  const history = useNavigate()
  const dispatch = useDispatch()
  const awardsListState = useSelector(state => state.awards.awardsList)
  const [awardsList, setAwardsList] = useState([])

  // Fetch Awards List API
  useEffect(() => {
    dispatch(getAwardsList({ offset: 1 }))
  }, [])

  useEffect(() => {
    if (awardsListState && awardsListState.length > 0) {
      const formattedData = awardsListState.map((item, index) => ({
        ...item,
        id: item.enc_award_id,
        title: item.title || "-",
        date: new Date(item.award_date).toLocaleDateString(),
        status: item.status || "-",
      }))

      setAwardsList(formattedData)
    }
  }, [awardsListState])

  const columns = useMemo(
    () => [
      {
        header: "Season",
        accessorKey: "title",
        enableColumnFilter: true,
        enableSorting: true,
      },
      {
        header: "Date",
        accessorKey: "date",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Status",
        accessorKey: "status_label",
        enableColumnFilter: false,
        enableSorting: true,
        cell: info => {
          const status = info.getValue()
          return (
            <span
              className={`badge ${
                status === "Active" ? "bg-success" : "bg-danger"
              }`}
            >
              {status}
            </span>
          )
        },
      },
      {
        header: "Action",
        accessorKey: "action",
        enableColumnFilter: false,
        enableSorting: false,
        cell: info => {
          const row = info.row.original
          return (
            <div className="d-flex gap-2 flex-wrap">
              <button
                className="btn btn-sm btn-warning"
                onClick={() => history(`/awards/nominations?id=${row.id}`)}
                title="View Nominations"
              >
                View Nominations
              </button>
              <button
                className="btn btn-sm btn-info"
                onClick={() =>
                  history(`/awards/categories/${row.enc_award_id}`)
                }
                title="Manage Categories"
              >
                Manage Categories
              </button>
              <button
                className="btn btn-sm btn-primary"
                onClick={() =>
                  history("/awards/edit-award", {
                    state: { url: row.url, enc_award_id: row.enc_award_id },
                  })
                }
                title="Edit Award"
              >
                Edit
              </button>
            </div>
          )
        },
      },
    ],
    [history]
  )

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-end mt-3 mb-3">
          <Button
            color="primary"
            onClick={() => history("/awards/add-award")}
          >
            Add Award
          </Button>
        </div>

        <TableContainer
          defaultPageSize={20}
          columns={columns}
          data={awardsList || []}
          isGlobalFilter={true}
          isPagination={true}
          isCustomPageSize={true}
          SearchPlaceholder="Search records..."
          pagination="pagination"
          isAddButton={false}
          buttonClass="btn btn-primary"
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
          theadClass="table-light"
          divClassName="table-responsive mb-4"
        />
      </div>
    </div>
  )
}

export default AwardsList
